import { ConvertDataPadrao } from './ConvertDataPadrao';

export default ConvertDataPadrao;